(() => {
  const updateCardVariant = (button) => {
    const card = button.closest('.product-card-wrapper');
    if (!card || button.disabled) return;

    card.querySelectorAll('[data-fk-card-variant]').forEach((variantButton) => {
      const isSelected = variantButton === button;
      variantButton.classList.toggle('is-selected', isSelected);
      variantButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    const variantInput = card.querySelector('[data-fk-card-variant-input]');
    if (variantInput) {
      variantInput.value = button.dataset.variantId;
      variantInput.disabled = button.dataset.available !== 'true';
    }

    const submitButton = card.querySelector('[data-fk-card-submit]');
    const submitText = card.querySelector('[data-fk-card-submit-text]');
    if (submitButton && submitText) {
      const isAvailable = button.dataset.available === 'true';
      submitButton.disabled = !isAvailable;
      submitButton.toggleAttribute('aria-disabled', !isAvailable);
      submitText.textContent = isAvailable ? (/[1-9]/.test(button.dataset.price || '') ? `Add · ${button.dataset.price}` : 'Add') : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    }

    const priceRow = card.querySelector('[data-fk-price-row]');
    const mrp = card.querySelector('[data-fk-mrp]');
    if (priceRow && mrp) {
      const compareAt = button.dataset.compareAt;
      mrp.innerHTML = compareAt ? `MRP <s>${compareAt}</s>` : '';
      priceRow.hidden = !compareAt;
    }

    const discount = card.querySelector('[data-fk-discount]');
    if (discount) {
      discount.textContent = button.dataset.discount || '';
      discount.hidden = !button.dataset.discount;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fk-card-variant]');
    if (button) updateCardVariant(button);
  });
})();
